let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("kd1UR")]).then(() => parcelRequire('ejLY3'));